import { useState } from "react";
import SellerStep from "../../components/seller/SellerStep";
import { SharedFormField } from "../../components/shared";
import ChoiceGroup from "../../components/forms/ChoiceGroup";
import { useSellerState } from "../../js/state/sellerState";
import { US_STATES } from "../../js/utils/checklistOptions";

export default function SellerPropertyDetails() {
  const saved = useSellerState().seller.portfolio.propertyDetails || {};
  const [form, setForm] = useState({
    street: saved.street || "",
    city: saved.city || "",
    state: saved.state || "",
    zip: saved.zip || "",
    propertyType: saved.propertyType || "",
    yearBuilt: saved.yearBuilt || "",
    beds: saved.beds || "",
    baths: saved.baths || "",
    sqft: saved.sqft || "",
    lotSize: saved.lotSize || "",
    stories: saved.stories || "",
    parking: saved.parking || "",
    hoa: saved.hoa || "",
    notes: saved.notes || "",
  });

  function update(event) {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  }

  return (
    <SellerStep
      title="Property details"
      lead="The facts a listing needs first — address, size, type, and how the property is held."
      sectionKey="propertyDetails"
      value={form}
    >
      <section className="checklist-section">
        <h2>Address</h2>
        <SharedFormField label="Street" name="street" value={form.street} onChange={update} placeholder="123 Main St" />
        <div className="two-col">
          <SharedFormField label="City" name="city" value={form.city} onChange={update} />
          <SharedFormField
            label="State"
            name="state"
            type="select"
            value={form.state}
            onChange={update}
            options={US_STATES}
          />
        </div>
        <SharedFormField label="ZIP" name="zip" value={form.zip} onChange={update} placeholder="00000" />
      </section>

      <section className="checklist-section">
        <h2>The Home</h2>
        <ChoiceGroup
          label="Property type"
          name="propertyType"
          value={form.propertyType}
          onChange={update}
          options={[
            { value: "single-family", label: "Single family" },
            { value: "townhouse", label: "Townhouse" },
            { value: "condo", label: "Condo" },
            { value: "multi", label: "Multi-family" },
            { value: "land", label: "Land / other" },
          ]}
        />
        <div className="two-col">
          <SharedFormField label="Year built" name="yearBuilt" value={form.yearBuilt} onChange={update} placeholder="1998" />
          <SharedFormField
            label="Stories"
            name="stories"
            type="select"
            value={form.stories}
            onChange={update}
            options={[
              { value: "1", label: "One" },
              { value: "1.5", label: "Split / 1.5" },
              { value: "2", label: "Two" },
              { value: "3+", label: "Three or more" },
            ]}
          />
        </div>
        <div className="two-col">
          <SharedFormField label="Bedrooms" name="beds" value={form.beds} onChange={update} />
          <SharedFormField label="Bathrooms" name="baths" value={form.baths} onChange={update} />
        </div>
        <div className="two-col">
          <SharedFormField label="Living area (sq ft)" name="sqft" value={form.sqft} onChange={update} />
          <SharedFormField label="Lot size" name="lotSize" value={form.lotSize} onChange={update} placeholder="sq ft or acres" />
        </div>
        <SharedFormField
          label="Parking"
          name="parking"
          type="select"
          value={form.parking}
          onChange={update}
          options={[
            { value: "garage-1", label: "1-car garage" },
            { value: "garage-2", label: "2-car garage" },
            { value: "garage-3", label: "3+ car garage" },
            { value: "carport", label: "Carport" },
            { value: "driveway", label: "Driveway only" },
            { value: "street", label: "Street / none" },
          ]}
        />
        <ChoiceGroup
          label="HOA"
          name="hoa"
          value={form.hoa}
          onChange={update}
          options={[
            { value: "yes", label: "Yes" },
            { value: "no", label: "No" },
            { value: "unsure", label: "Not sure" },
          ]}
        />
        <SharedFormField
          label="Notes for my agent"
          name="notes"
          type="textarea"
          value={form.notes}
          onChange={update}
          placeholder="Legal description quirks, easements, ADU, recent survey, etc."
        />
      </section>
    </SellerStep>
  );
}
